import { useParams } from 'react-router';

import { EpsiDetail } from '../../epsi/manager/EpsiDetail';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerEpsiDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { manager, apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager && manager?.modules?.epsi ? (
        <AppWrapper appType={APP_TYPE.MANAGER} menu={<ManagerMenu />}>
          <EpsiDetail docId={parseInt(id!, 10)} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerEpsiDetailPage;
